import { API_BASE_URL as GLOBAL_API_BASE_URL } from 'consts';

export const API_BASE_URL = process.env.API_SCHEDULE_URL || GLOBAL_API_BASE_URL;
